import React, { useEffect } from 'react';
import { Button, Form } from 'antd';
import { PayoutAccountFields, PAYOUT_FORM_DEFAULTS, filledPayoutValues } from 'components/CredentialingPayoutForm';
import type { ProviderCredentialingPayoutAccountDto } from '../types';
import { payoutComplete } from '../validators';
import s from '../common.module.less';

interface Props {
    // 宿主持有的完整账户（已存 detail 叠上本次编辑），保存时整份提交
    value: ProviderCredentialingPayoutAccountDto;
    onChange: (dto: ProviderCredentialingPayoutAccountDto) => void;
    onContinue: () => void;
    // group：practice 只有一个账户，第一个 provider 填过后每个 provider 都预填同一个
    group?: boolean;
    continueLabel?: string;
    flush?: boolean;
    onBack?: () => void;
    saving?: boolean;
}

// Medicare payout（原型 showPayoutStepModal，09/24 + 10/15/16）：选了 Medicare 时把收款账户提到
// payer 步骤链里（Service address 之后），Medicare 只按 EFT 付款。字段与 dashboard 弹窗 / Settings 同一套
const MedicarePayoutStep = ({
    value,
    onChange,
    onContinue,
    onBack,
    saving,
    group,
    continueLabel = 'Continue',
    flush,
}: Props) => {
    const [form] = Form.useForm<ProviderCredentialingPayoutAccountDto>();

    // 宿主异步水合完已存账户后回填一次；之后表单是数据源，onValuesChange 回写宿主
    useEffect(() => {
        form.setFieldsValue({ ...PAYOUT_FORM_DEFAULTS, ...filledPayoutValues(value) });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleContinue = async () => {
        try {
            await form.validateFields();
        } catch {
            return;
        }
        onContinue();
    };

    return (
        <>
            <div className={`${s.modalBody} ${flush ? s.flushBody : ''}`}>
                {group && (
                    <p className={s.payoutGroupNote}>
                        One account for the practice. Fill it on the first provider and everyone you add after opens
                        with it already filled in.
                    </p>
                )}
                <Form
                    form={form}
                    layout="vertical"
                    initialValues={PAYOUT_FORM_DEFAULTS}
                    onValuesChange={(_, all) => onChange({ ...value, ...all })}
                >
                    <PayoutAccountFields onAutoFill={() => onChange({ ...value, ...form.getFieldsValue() })} />
                </Form>
            </div>
            <div className={`${s.modalFooter} ${flush ? s.flushFooter : ''}`}>
                <Button
                    type="primary"
                    block
                    size="large"
                    className={s.primaryBtn}
                    disabled={!payoutComplete({ ...PAYOUT_FORM_DEFAULTS, ...value })}
                    loading={saving}
                    onClick={handleContinue}
                >
                    {continueLabel}
                </Button>
                {onBack && (
                    <Button block size="large" className={s.backBtn} onClick={onBack}>
                        Back
                    </Button>
                )}
            </div>
        </>
    );
};

export default MedicarePayoutStep;
